import { render, staticRenderFns } from "./ReceiveMaterialList.vue?vue&type=template&id=80a24020&lang=pug&"
import script from "./ReceiveMaterialList.vue?vue&type=script&lang=ts&"
export * from "./ReceiveMaterialList.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiveMaterialList.vue?vue&type=style&index=0&id=80a24020&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports